import $ from 'jquery';

const gridDebugInit = () => {
    const $component = $('.c-grid-debug');
    if (!$component.length) { return; }

    $component.click(() => {
        $component.toggleClass('active');
    });
};

// doc ready
$(() => {
    gridDebugInit();
});



// WEBPACK FOOTER //
// ./src/components/grid-debug/c-grid-debug.js